import React from 'react'
import {
    VStack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'

//UTIL
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import SanitizedHtml from '../../../components/html-sanitizer'

export default function FaqTitle({title}) {
    const styles = useMultiStyleConfig('Faq', {})
    const {searchAndTitleStyles} = styles || {}

    return (
        <VStack {...searchAndTitleStyles?.outerContainer}>
            <VStack {...searchAndTitleStyles?.midContainer}>
                <VStack {...searchAndTitleStyles?.innerContainer}>
                    {/**Since the title of the category is in the native language there is no need for a formatted message */}
                    {title === 'default' ? (
                        <Text {...searchAndTitleStyles?.titleText} as="h1">
                            <FormattedMessage
                                id="faq_page.search.title"
                                defaultMessage="Frequent Questions"
                            />
                        </Text>
                    ) : (
                        <SanitizedHtml
                            as={Text}
                            html={title}
                            {...searchAndTitleStyles?.titleText}
                            sanitize={true}
                        />
                    )}
                </VStack>
            </VStack>
        </VStack>
    )
}

FaqTitle.propTypes = {
    title: PropTypes.string,
    searchActive: PropTypes.bool,
}
